export enum PaymentItemType {
  TICKET = 'TICKET',
  INVOICE = 'INVOICE',
}
